/* eslint-disable */
import React from 'react';
import * as MUI from '@material-ui/core';
import { useStyles } from './styles';
import FolderIcon from '../../../../../../icons/Folder';

export const CategoryTitle = ({ children, ...props }) => {
  const { parent } = props;
  const { toggleExpand } = parent as any;
  const classes = useStyles(props);
  return (
    <MUI.AccordionSummary className={classes.categoryTitle} onClick={toggleExpand}>
      <FolderIcon className={classes.categoryTitleIcon} />
      {children}
    </MUI.AccordionSummary>
  );
}

export default CategoryTitle;
